module.exports = __webpack_public_path__ + "img/tcApi_result_addInfo.96fe28ef.png";